import { Box, Heading, RadioGroup, RadioGroupProps } from '@wix/design-system'
import { ChoiceQuestionContentComponent } from '@wix/funnel-builder-lizard'
import React, { FC } from 'react'
import { useMediaQuery } from 'react-responsive'

import { PageLogger } from '../../../../bi/mfi'
import { HEADLESS_MOBILE } from '../../../../breakpoints'
import { dataHooks } from './Question.dataHooks'
import s from './Question.scss'

export type Content = ChoiceQuestionContentComponent<{ title: string }, { label: string }>

type Props = Content & {
  selectedOptionKey?: string
  onChange: (newValue: string) => void
  pageLogger: PageLogger
  dataHook?: string
}

export const Question: FC<Props> = ({
  questionKey,
  content,
  options,
  selectedOptionKey,
  onChange,
  pageLogger,
  dataHook,
}) => {
  const isMobileView = useMediaQuery(HEADLESS_MOBILE)
  const handleChange: RadioGroupProps['onChange'] = rawValue => {
    const value = String(rawValue)

    void pageLogger.clickAnswer({ questionKey, buttonName: value })
    onChange(value)
  }

  return (
    <Box direction="vertical" gap="SP4" width="100%" dataHook={dataHook}>
      <Heading size="medium" dataHook={dataHooks.title()}>
        {content.title}
      </Heading>
      <RadioGroup
        value={selectedOptionKey}
        onChange={handleChange}
        selectionArea="always"
        selectionAreaSkin="outlined"
        selectionAreaPadding="12px 18px"
        display={isMobileView ? 'vertical' : 'horizontal'}
        className={s.radioGroup}
        spacing="18px"
      >
        {options.map(option => (
          <RadioGroup.Radio key={option.optionKey} value={option.optionKey}>
            {option.label}
          </RadioGroup.Radio>
        ))}
      </RadioGroup>
    </Box>
  )
}
